import { createSlice } from "@reduxjs/toolkit";
import { getMaterialAPI } from "../../../services/guestUsers/guestUserAllAPIService";
const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
};

const getMaterialSlice = createSlice({
  name: "getMaterialSlice",
  initialState: data,
  reducers: {
    getMaterialSliceInfo(state) {
      state.isLoading = true;
    },
    getMaterialSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = "";
    },
    getMaterialSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
      state.data = null;
    },
    getMaterialSliceReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
    },
  },
});

export const getMaterialHandler = (data) => async (dispatch) => {
  try {
    dispatch(getMaterialSliceAction.getMaterialSliceInfo());
    const response = await getMaterialAPI(data);
    dispatch(getMaterialSliceAction.getMaterialSliceSuccess(response));
  } catch (e) {
    	dispatch(getMaterialSliceAction.getMaterialSliceFailure(e));
  }
};
	export default getMaterialSlice.reducer;
export const getMaterialSliceAction = getMaterialSlice.actions;
